/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WorkspaceService } from "../../service/WorkspaceService";
const initialState = {
    loading: false,
    workspace: [],
    workspaceById: [],
    selectedWorkspace: {},
    CreateWorkSpaceBilling: {},
};
const action = {
    create: createAsyncThunk("workspace/create", async (payload, thunkAPI) => {
        return (await WorkspaceService.create(thunkAPI, payload.data)).data;
    }),
    readWorkSpace: createAsyncThunk("workspace/read", async (_, thunkAPI) => {
        return (await WorkspaceService.read(thunkAPI)).data;
    }),
    readWorkSpaceByUserId: createAsyncThunk("workspace/readByUserId", async (payload, thunkAPI) => {
        return (await WorkspaceService.readByUserId(thunkAPI, payload)).data;
    }),
    updateWorkSpace: createAsyncThunk("workspace/update", async (payload, thunkAPI) => {
        return (await WorkspaceService.update(thunkAPI, payload.data)).data;
    }),
    deleteWorkSpace: createAsyncThunk("workspace/delete", async (payload, thunkAPI) => {
        return (await WorkspaceService.delete(thunkAPI, payload.data)).data;
    })
};
const slice = createSlice({
    name: "workspace",
    initialState,
    reducers: {
        setLoading(state, { payload }) {
            state.loading = payload;
        },
        setSelectedWorkspace(state, { payload }) {
            state.selectedWorkspace = payload;
        },
        setCreateWorkSpaceBilling(state, { payload }) {
            state.CreateWorkSpaceBilling = payload;
        }
        // setCurrentWorkspaceId(state, {payload}) {
        //   state.currentWorkspaceId = {workspaceId: payload.id, workspaceName: payload.name};
        // },
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.create.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.create.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            .addCase(action.readWorkSpace.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.readWorkSpace.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                state.workspace = response.data;
            }
        }).addCase(action.readWorkSpaceByUserId.pending, (state) => {
            state.loading = true;
        }).addCase(action.readWorkSpaceByUserId.fulfilled, (state, action) => {
            state.loading = false;
            const response = action.payload;
            if (response.responseCode == "00") {
                state.workspaceById = response.data;
            }
        }).addCase(action.updateWorkSpace.pending, (state) => {
            state.loading = true;
        }).addCase(action.updateWorkSpace.fulfilled, (state, action) => {
            state.loading = false;
            const response = action.payload;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.deleteWorkSpace.pending, (state) => {
            state.loading = true;
        }).addCase(action.deleteWorkSpace.fulfilled, (state, action) => {
            state.loading = false;
            const response = action.payload;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        });
    },
});
export const workspace = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
